import { Box, FormControl, TextField } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import React, { useEffect, useState } from "react";
import { checkIfIsIndependentUser } from "../../auth/Utils";

export const IdentifierAutoComplete = ({
  // TODO: make this StudentAutoComplete and update throughout frontend
  availableIdentifiers,
  identifier,
  setIdentifier,
  identifierWarningMessage = "",
  isIndependentUser = null,
}) => {
  const resolvedIsIndependentUser =
    isIndependentUser !== null ? isIndependentUser : checkIfIsIndependentUser();

  const makeDisplayLabel = (obj) => {
    if (typeof obj === "string") return obj;
    if (!obj) return "";
    if (typeof obj.identifier === "string" && obj.identifier.length > 0)
      return obj.identifier;
    const first = obj.firstName || "";
    const last = obj.lastName || "";
    const full = `${first} ${last}`.trim();
    return full || "";
  };

  const [inputValue, setInputValue] = useState(makeDisplayLabel(identifier));

  useEffect(() => {
    setInputValue(makeDisplayLabel(identifier));
  }, [identifier]);

  const handleChange = (newValue) => {
    setInputValue(newValue ? newValue : "");
    if (newValue === null) {
      // User cleared input — set to empty object instead of null
      setIdentifier({});
    } else if (typeof newValue === "string") {
      if (resolvedIsIndependentUser) {
        setIdentifier({ id: null, identifier: newValue });
      }
    } else {
      // selected option object
      setIdentifier(newValue);
    }
  };
  return (
    <Box sx={{ mt: 2 }}>
      <FormControl fullWidth>
        <Autocomplete
          freeSolo={resolvedIsIndependentUser}
          options={availableIdentifiers}
          getOptionLabel={(option) => makeDisplayLabel(option)}
          value={identifier}
          inputValue={inputValue}
          onInputChange={(_, newInputValue) => handleChange(newInputValue)}
          onChange={(_, newValue) => handleChange(newValue)}
          isOptionEqualToValue={(option, value) => option?.id === value?.id}
          renderInput={(params) => (
            <TextField
              {...params}
              error={identifierWarningMessage ? identifierWarningMessage : ""}
              helperText={identifierWarningMessage}
              label={
                resolvedIsIndependentUser
                  ? "Student Identifier"
                  : "Select Student"
              }
              sx={{
                "& .MuiOutlinedInput-root": {
                  border: "none", // Remove border
                },
              }}
            />
          )}
          sx={{ width: "100%" }}
          slotProps={{
            clearIndicator: {
              sx: {
                border: "none",
                boxShadow: "none",
                "&:hover": {
                  background: "transparent",
                },
                height: 5,
              },
            },
            popupIndicator: {
              sx: {
                border: "none",
                boxShadow: "none",
                "&:hover": { background: "transparent" },
              },
            },
          }}
        />
      </FormControl>
    </Box>
  );
};
